import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation deleteMerchantNameMutation(
    $input: DeleteMerchantNameInput!
    $storeId: ID!
  ) {
    deleteMerchantName(input: $input) {
      destroyedMerchantNameId
      storeLists {
        ...MerchantNames_storeLists
      }
    }
  }
`;

const deleteMerchantName = (environment, params, listsId, args = {}) => {
  const { id, storeId } = params;
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id,
      },
      storeId,
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'MerchantNames_storeLists' }],
        pathToConnection: ['lists', 'merchantNames'],
        deletedIDFieldName: 'destroyedMerchantNameId',
      },
    ],
    ...args,
  });
};

export default deleteMerchantName;
